@if (client$ | async; as client) {
  @if (signaalkaarten$ | async; as signaalkaarten) {
    @if (signaalkaartAntwoordenPage$ | async; as signaalkaartAntwoordPage) {
      <zah-client-header label="Signaalkaarten"
        [client]="client">
      </zah-client-header>
      <div class="signaalkaarten">
        <zah-signaalkaart-antwoorden [signaalkaarten]="signaalkaarten"
          [initialPageRequest]="initialPageRequest"
          [signaalkaartAntwoordenPage]="signaalkaartAntwoordPage"
          (signaalkaartAntwoordClicked)="navigateToSignaalkaartAntwoord(client, $event)"
          (pageChange)="onPageChange(client, $event)">
        </zah-signaalkaart-antwoorden>
      </div>
      <button mat-mini-fab
        color="primary"
        class="back-button"
        (click)="navigateToClient(client)">
        <mat-icon>arrow_back</mat-icon>
      </button>
    }
  }
}
